import { Box, Container, useMediaQuery, useTheme } from '@mui/material'
import { useState } from 'react'
import CustomButton from 'Components/CustomButton/CustomButton'
import { makeDeleteRequest } from 'utils/api'
import urls from 'utils/urls'
import { Fragment } from 'react'
import CreateTache from '../CreateTache'
import { isObject } from 'lodash'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import EditIcon from '@mui/icons-material/Edit'
import TaskPng from 'Components/images/Task Icon big.png'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import CreateMessage from 'containers/MyInbox/CreateMessage'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
export const MNotes = ({
  row,
  CreateNoteModal,
  updateTodo = false,
  notesList,
  setNotesList,
  setNoteRow,
}) => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [mOpen, setMOpen] = useState(false)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [createTache, setCreateTache] = useState(false)
  const CreateTacheModal = () => {
    setCreateTache(true)
  }
  const onNoteDel = async (NoteId) => {
    const filteredNotes = notesList.filter((v) => NoteId !== v.id)
    setNotesList(filteredNotes)
    const response = await makeDeleteRequest(urls.noteOperations + `${NoteId}/`, {}, true)
    if (response.status === 204) {
      setNoteRow(notesList?.length > 0 ? notesList[0] : {})
    }
  }

  return (
    <>
      {mOpen && (
        <CreateMessage setMOpen={setMOpen} title={t('mesToDo.shareNote')} settingId={11} note={row} />
      )}
      <Container maxWidth="xl">
        <Box justifyContent="flex-end" padding={2} display="flex">
          <Box>
            {isMobile ? (
              <Box
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                color={'white'}
                gap={2}
              >
                <AddCircleIcon
                  onClick={() => {
                    CreateNoteModal()
                  }}
                />

                <RemoveCircleIcon onClick={() => onNoteDel(row.id)} />
                <EditIcon onClick={() => CreateNoteModal(row)} />
                <DoneAllIcon
                  onClick={() => {
                    CreateTacheModal()
                  }}
                />
              </Box>
            ) : (
              <>
                <CustomButton
                  onClick={() => {
                    setMOpen(true)
                  }}
                >
                  {t('mesToDo.share')}
                </CustomButton>
                <CustomButton onClick={() => CreateNoteModal(row)}>{t('mesToDo.edit')}</CustomButton>
                <CustomButton
                  onClick={() => {
                    CreateNoteModal()
                  }}
                >
                  {t('mesToDo.add')}
                </CustomButton>
                <CustomButton onClick={() => onNoteDel(row.id)}>{t('mesToDo.deleteNote')}</CustomButton>
                <CustomButton
                  onClick={() => {
                    CreateTacheModal()
                  }}
                >
                  {t('mesToDo.convertToTask')}
                </CustomButton>
              </>
            )}
          </Box>
        </Box>
        {notesList?.length > 0 && (
          <>
            <Box sx={{ color: 'white', textAlign: 'left' }} variant="h6" component="h3">
              {row.Titre}
            </Box>
            <Box sx={{ color: 'white', marginTop: '10px' }}>
              {row.Details.split('\n').map((item, index) => {
                return (
                  <Fragment key={index}>
                    {item}
                    <br />
                  </Fragment>
                )
              })}
            </Box>
          </>
        )}
      </Container>
      {createTache && (
        <CreateTache
          setCreateTache={setCreateTache}
          updateTodo={updateTodo}
          row={row}
          onNoteDel={onNoteDel}
        />
      )}
    </>
  )
}
